import { styled, lighten } from "@mui/material/styles";
import { Table, Grid, darken } from "@mui/material";

export const Container = styled(Grid)({
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  padding: "10px 0px",
  alignItems: "center",
});
export const StyledTable = styled(Table)(({ theme }) => ({
  width: "100%",
  "& .MuiTableRow-root": {
    "& .MuiTableCell-root": {
      borderBottom: "none",
      padding: "0",
      alignItems: "center",
      gap: "3px",
      height: "30px",
      "& .MuiTypography-root": {
        // color: lighten(theme.palette.text.secondary, 0.3),
        color: darken(theme.palette.text.secondary, 0.15),
        cursor: "pointer",
      },
      "&:first-of-type": {
        width: "50%",
      },
      "&:nth-of-type(2)": {
        display: "flex",
      },
    },

    "& hr": {
      height: "8px",
      borderRadius: "10px",
      border: "none",
      marginLeft: "unset",
    },
  },
}));
